import * as React from "react";
import { ContactPageComp } from "../Components/ContactPageComp";


// markup
const ContactPage = (props) => {
  return <ContactPageComp props={props} />;
};

export default ContactPage;
